import React from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from 'formlabs-web-components/BaseComponents/DisplayComponent';
import Link from 'formlabs-web-components/Link/Link';
import Button from 'formlabs-web-components/Link/Button';
import Picture from 'formlabs-web-components/Media/Picture';

import './BasicTile.module.css';

const BasicTile = ({ ctaText, image, imageAlt, url, classes }) => (
  <Link className={classes} to={url}>
    <div styleName="basic-tile">
      <Picture largeImage={image} alt={imageAlt} />
      <p>
        <Button to={url} arrow="right-caret" color="inherit-color">
          {ctaText}
        </Button>
      </p>
    </div>
  </Link>
);

BasicTile.propTypes = {
  ctaText: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  classes: PropTypes.any
};

export default DisplayComponent(BasicTile);
